/* eslint-disable no-restricted-globals */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
	Panel, Button, Dropdown, MenuItem,
} from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import {
	isEqual, cloneDeep, indexOf, isEmpty, get, includes, find,
} from 'lodash';
import classNames from 'classnames';
import utils, { constants } from '@utils';
import { Image } from '@components/common';

class DetailsRowComponent extends Component {
	constructor(props) {
		super(props);

		let expandablePanelsCount = 0;

		props.row.Jobs.forEach((job) => {
			if (job.AssignedOfficersCount > 0) expandablePanelsCount++;
		});

		this.state = {
			expandablePanelsCount,
			expandedPanels : [],
		};
	}

	static getDerivedStateFromProps(nextProps, lastState) {
		let expandablePanelsCount = 0;

		nextProps.row.Jobs.forEach((job) => {
			if (job.AssignedOfficersCount > 0) expandablePanelsCount++;
		});

		if (!isEqual(expandablePanelsCount, lastState.expandablePanelsCount)) return { expandablePanelsCount };

		return null;
	}

	shouldComponentUpdate = ({ row, timeZoneId }, { expandedPanels }) => {
		const lastProps = this.props;
		const lastState = this.state;

		return (
			!isEqual(row.Id, lastProps.row.Id)
			|| !isEqual(row.Jobs, lastProps.row.Jobs)
			|| !isEqual(timeZoneId, lastProps.timeZoneId)
			|| !isEqual(expandedPanels, lastState.expandedPanels)
		);
	}

	toggleExpansion = (panelIndex) => () => {
		const newState = cloneDeep(this.state);

		if (!this.isExpanded(panelIndex)) newState.expandedPanels.push(panelIndex);
		else {
			const index = indexOf(newState.expandedPanels, panelIndex);

			newState.expandedPanels.splice(index, 1);
		}

		this.setState(newState);
	}

	isExpanded = (index) => {
		const { expandedPanels } = this.state;
		return includes(expandedPanels, index);
	}

	expandAll = () => {
		const jobs = get(this.props, ['row', 'Jobs'], []);
		const { expandablePanelsCount } = this.state;
		let { expandedPanels } = cloneDeep(this.state);

		if (expandablePanelsCount === expandedPanels.length) expandedPanels = [];
		else {
			jobs.forEach((job, index) => {
				if (job.AssignedOfficersCount > 0 && !includes(expandedPanels, index)) expandedPanels.push(index);
			});
		}

		this.setState({ expandedPanels });
	}

	getTagClass = (officer) => {
		const officerStatusType = get(officer, 'OfficerStatus', 0);
		const status = find(constants.OFFICER_STATUSES, ['type', officerStatusType]) || constants.OFFICER_STATUSES.none;

		return `tag-${status.color}`;
	}

	getStatusDescription = (officer) => {
		const officerStatusType = get(officer, 'OfficerStatus', 0);
		const status = find(constants.OFFICER_STATUSES, ['type', officerStatusType]) || constants.OFFICER_STATUSES.none;

		return status.description;
	}

	renderActionButton = (officerId) => {
		const { row : { Id }, viewType } = this.props;
		return (
			<div className="officer-actions">
				<Dropdown
					id={`officer_dropdown_${officerId}_${Id}`}
				>
					<Dropdown.Toggle className="color-black">
						Actions
					</Dropdown.Toggle>
					<Dropdown.Menu className="simple-dropdown-menu">
						<LinkContainer to={`/jobs/${Id}`}>
							<MenuItem eventKey="1">
								View Details
							</MenuItem>
						</LinkContainer>
						<LinkContainer to={`/jobs/map/${viewType}/${Id}`}>
							<MenuItem eventKey="2">
								View in Map
							</MenuItem>
						</LinkContainer>
					</Dropdown.Menu>
				</Dropdown>
			</div>
		);
	}

	render() {
		const {
			timeZoneId,
			row,
		} = this.props;
		const { Id, Jobs, JobEventTypeId } = row;
		const { expandablePanelsCount, expandedPanels } = this.state;
		const allPanelsExpanded = expandablePanelsCount === expandedPanels.length;

		return (
			<div className="job-details-row">
				<div className="flex flex-align-items-center flex-justify-content-space-between margin-bottom-27">
					<h3>List of Positions</h3>
					<div>
						<If condition={expandablePanelsCount > 0}>
							<Button onClick={this.expandAll}>
								<i className={classNames('fa', 'margin-right-5',
									{
										'fa-minus-circle' : allPanelsExpanded,
										'fa-plus-circle'  : !allPanelsExpanded,
									})}
								/>
								{ allPanelsExpanded ? 'Collapse All' : 'Expand All' }
							</Button>
						</If>
						<Link
							className="btn btn-primary btn-medium margin-left-10"
							to={`/jobs/${Id}`}
						>
							View Details
						</Link>
					</div>
				</div>
				<div>
					<For
						each="job"
						of={Jobs}
						index="index"
					>
						<Panel
							key={`panel_${job.Id}_${index}`}
							expanded={this.isExpanded(index)}
							onToggle={() => {}}
							className="bg-gray-12 padding-0 margin-0"
						>
							<Panel.Heading className="bg-inherit border-bottom-0 padding-vertical-2em">
								<div className="flex flex-center">
									<div className="flex-4 margin-left-30">
										<h4 className="font-heavy font-size-16">
											{ job.Title }
										</h4>
										<If condition={JobEventTypeId === constants.FORM_JOB_TYPES.EVENT.value}>
											<p className="font-size-12 margin-top-5 margin-bottom-0">
												<span>{ utils.parseUTCDateToTimeZone(job.StartDateTime, timeZoneId).format('h:mm A') }</span>
												<span> - </span>
												<span>{ utils.parseUTCDateToTimeZone(job.EndDateTime, timeZoneId).format('h:mm A') }</span>
											</p>
										</If>
										<If condition={job.OfficerRequirements}>
											<p className="color-gray-dove font-size-12">
												Requirements:
												{' '}
												{ job.OfficerRequirements }
											</p>
										</If>
									</div>
									<div className="flex-1">
										<h4 className="margin-bottom-5">
											{ utils.currencyFormatter(job.Rate, false) }
										</h4>
										<p className="color-gray-dove font-size-12">
											Rate/Hour
										</p>
									</div>
									<div className="flex-1">
										<h4 className="margin-bottom-5">
											{ job.AssignedOfficersCount }
											/
											{ job.OfficersNeeded }
										</h4>
										<p className="color-gray-dove font-size-12">
											Filled
										</p>
									</div>
									<div className="flex flex-justify-content-center flex-1 ">
										<If condition={!isEmpty(job.AssignedOfficers) || !isEmpty(job.ExternalOfficers)}>
											<Button
												onClick={this.toggleExpansion(index)}
												className="transition-none margin-right-30"
											>
												<i className={classNames('fa', 'margin-right-5',
													{
														'fa-minus-circle' : this.isExpanded(index),
														'fa-plus-circle'  : !this.isExpanded(index),
													})}
												/>
												Officers
											</Button>
										</If>
									</div>
								</div>
							</Panel.Heading>
							<Panel.Collapse className="panel-officer-positions">
								<For
									index="index"
									each="officer"
									of={job.AssignedOfficers}
								>
									<Panel
										key={`officer_${index}_${officer.Id}`}
										className="thin-panel bg-white"
									>
										<div className="officer-row">
											<div>
												<div className="flex margin-left-10">
													<Image
														src={officer.OfficerProfile.ContactPhotoUrl}
														className="img-avatar border-radius-round margin-right-25"
														fallbackSrc="avatar"
													/>
													<div className="flex-direction-column">
														<div>
															<div className="margin-bottom-5 font-medium font-size-14">
																{ officer.OfficerProfile.FirstName }
																{' '}
																{ officer.OfficerProfile.LastName }
															</div>
															<If condition={officer.OfficerProfile.OfficerRank && officer.OfficerProfile.JurisdictionName}>
																<p className="color-gray-dove font-size-12">
																	{ officer.OfficerProfile.OfficerRank }
																	{' '}
																	|
																	{ officer.OfficerProfile.JurisdictionName }
																</p>
															</If>
														</div>
													</div>
												</div>
											</div>
											<If condition={officer.OfficerStatus >= 1}>
												<div className="text-center officer-times">
													<div>
														<h4 className="margin-bottom-5">
															{ officer.ClockIn
																? utils.parseUTCDateToTimeZone(officer.ClockIn, timeZoneId).format('hh:mm A')
																: '-' }
														</h4>
														<p className="color-gray-santas font-size-12">
															Clock-In
														</p>
													</div>
													<div className="separator" />
													<div>
														<h4 className="margin-bottom-5">
															{ officer.ClockOut
																? utils.parseUTCDateToTimeZone(officer.ClockOut, timeZoneId).format('hh:mm A')
																: '-' }
														</h4>
														<p className="color-gray-santas font-size-12">Clock-Out</p>
													</div>
												</div>
											</If>
											<If condition={officer.OfficerStatus !== 0}>
												<div className="officer-badge">
													<div className={classNames('tag', this.getTagClass(officer))}>
														{ this.getStatusDescription(officer) }
													</div>
												</div>
											</If>
											{ this.renderActionButton(officer.Id) }
										</div>
									</Panel>
								</For>
								<For
									index="index"
									each="external"
									of={job.ExternalOfficers}
								>
									<Panel
										key={`officer_${index}_${external.Id}`}
										className="thin-panel bg-white"
									>
										<div className="officer-row">
											<div>
												<div className="flex">
													<Image
														src={null}
														className="img-avatar border-radius-round margin-right-25"
													/>
													<div className="flex-direction-column">
														<div>
															<div className="margin-bottom-5 font-medium font-size-14">
																{ external.OfficerName }
															</div>
															<p className="color-gray-dove font-size-12">
																Non-RollKall Officer
															</p>
														</div>
													</div>
												</div>
											</div>
											{ this.renderActionButton(external.Id) }
										</div>
									</Panel>
								</For>
							</Panel.Collapse>
						</Panel>
					</For>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (
	{
		app    : { user : { TimeZoneId : timeZoneId } },
		router : { match : { params : { viewType } } },
	},
) => ({
	timeZoneId,
	viewType,
});

DetailsRowComponent.propTypes = {
	row        : PropTypes.object.isRequired,
	timeZoneId : PropTypes.string,
	viewType   : PropTypes.string,
};

DetailsRowComponent.defaultProps = {
	timeZoneId : '',
	viewType   : '',
};

export default connect(mapStateToProps)(DetailsRowComponent);
